"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollShadow = exports.root = exports.loadMoreButton = void 0;

var _util = require("../../../util");

const loadMoreButton = ({
  theme
}) => ({
  bottom: (0, _util.spacing)(theme, 'medium'),
  left: '50%',
  position: 'absolute',
  transform: 'translate(-50%)',
  '&:after': {
    content: "''",
    borderRadius: 100,
    bottom: 0,
    boxShadow: "0 0 16px ".concat((0, _util.color)(theme, 'overlay1')),
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
  }
});

exports.loadMoreButton = loadMoreButton;

const root = () => ({
  position: 'relative',
  width: '100%',
  zIndex: 0
});

exports.root = root;

const scrollShadow = ({
  cssProps,
  theme
}) => {
  const {
    active,
    direction
  } = cssProps;
  return {
    [direction]: -1,
    background: (0, _util.color)(theme, 'overlay2'),
    bottom: 0,
    boxShadow: (0, _util.boxShadow)(theme, [0, 0, 4, 'overlay2']),
    opacity: active ? 1 : 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    transition: 'opacity 0.2s ease',
    width: 1,
    zIndex: 1
  };
};

exports.scrollShadow = scrollShadow;
//# sourceMappingURL=OptionChain.style.js.map